import { useEffect, useState } from 'react';
import { Modal } from '@fasstech/middle-design-system';
import PropTypes from 'prop-types';
import {
  isEmailValid,
  isEmailValidAndRequired,
  isForeignPhoneNumberValid,
  isMobilePhoneNumberValid
} from '@@viewHelpers/validations';
import {
  RESIDENCE_COUNTRY_FIELD,
  isForeignResidence,
  pickPhoneIndicatives
} from '@@viewHelpers/residenceCountry.js';
import DisplayErrorMessage from '@@viewCommonComponents/displayer/DisplayErrorMessage';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';
import {
  ControlledInput,
  ControlledPhoneInput
} from '@@viewCommonComponents/controlled';
import { equals, not } from 'ramda';

const IndividualConfirmationModal = ({
  isDisplayed,
  phoneIndicatives,
  internationalPhoneIndicatives,
  confirm,
  getMiddleText,
  close,
  form
}) => {
  const [displayError, setDisplayError] = useState(false);

  const { watch } = form;

  const mailValues = watch('customer.emails.0.value');
  const phoneValues = watch('customer.phones.0.number');

  const residenceCountry = watch(RESIDENCE_COUNTRY_FIELD);
  const mobileRules = isForeignResidence(residenceCountry)
    ? isForeignPhoneNumberValid()
    : isMobilePhoneNumberValid();

  const phoneFormatIsValid = equals(true, mobileRules.validate(phoneValues));

  useEffect(() => {
    if (
      isNilOrEmpty(mailValues) ||
      isNilOrEmpty(phoneValues) ||
      not(isEmailValid(mailValues)) ||
      not(phoneFormatIsValid)
    ) {
      return setDisplayError(true);
    } else {
      setDisplayError(false);
    }
  }, [mailValues, phoneValues, phoneFormatIsValid]);

  return (
    <Modal
      isDisplayed={isDisplayed}
      button1Label={'Confirmer l\'exactitude de ces informations'}
      button2Label={'Annuler'}
      onClose={close}
      onClick1={confirm}
      onClick2={close}
      icon="circleReject"
    >
      <div className="text-2xl font-semibold mb-4">
        Vérifiez ces informations
      </div>

      <div className="inline-flex w-full gap-2">
        <ControlledPhoneInput
          name="customer.phones.0"
          label={getMiddleText('ADHERENT_TEL_MOBILE_LABEL')}
          form={form}
          rules={mobileRules}
          options={pickPhoneIndicatives(residenceCountry, {
            french: phoneIndicatives,
            international: internationalPhoneIndicatives
          })}
          containerClassName="md:w-full!"
          data-testid="CUSTOMER_PHONE_INPUT"
        />
      </div>

      <ControlledInput
        name="customer.emails.0.value"
        label={getMiddleText('ADHERENT_EMAIL_LABEL')}
        form={form}
        rules={isEmailValidAndRequired}
        containerClassName="mt-4 md:w-full!"
        data-testid="customerEmail"
      />

      {displayError && (
        <DisplayErrorMessage
          text={getMiddleText(
            'GENERAL_COMMON_TEXTS_TAB_ACTION_ERROR_WARNING_DESCRIPTION'
          )}
        />
      )}
    </Modal>
  );
};

IndividualConfirmationModal.propTypes = {
  isDisplayed: PropTypes.bool,
  phoneIndicatives: PropTypes.array,
  internationalPhoneIndicatives: PropTypes.array,
  confirm: PropTypes.func,
  getMiddleText: PropTypes.func,
  close: PropTypes.func,
  form: PropTypes.object
};

export default IndividualConfirmationModal;
